import { render } from "./VipCard.vue?vue&type=template&id=1e724f6d&scoped=true&ts=true"
import script from "./VipCard.vue?vue&type=script&lang=ts"
export * from "./VipCard.vue?vue&type=script&lang=ts"

import "./VipCard.vue?vue&type=style&index=0&id=1e724f6d&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e724f6d"]])

export default __exports__